import { SMX_PREBID_JS } from "@components/Advertisement/utils/constants";
import useScript from "@hooks/useScript";
import { IS_PLAYWRIGHT } from "@util/constant";

const ClientAdSettingsContent = (): React.ReactElement => {
  useScript({
    id: "sphdigital-adtag",
    src: "https://adtag.sphdigital.com/tag/smx/prebid.js",
    type: "text/javascript",
    checkScriptIsLoaded: () => {
      // Disable loading adtag script if
      // - ran from playwright
      return IS_PLAYWRIGHT;
    },
  });

  useScript({
    id: "smx-prebid-js",
    src: SMX_PREBID_JS,
    type: "text/javascript",
  });

  useScript({
    id: "bt-ads-js",
    src: "/_web2/3.1.2/bt_ads.js?v=3.1.2",
    type: "text/javascript",
    defer: true,
  });

  useScript({
    id: "betterads-head2-js",
    src: "/_web2/betterads_head2.js?v=3.1.2",
    type: "text/javascript",
    defer: true,
  });

  return <></>;
};

export default ClientAdSettingsContent;
